import { createI18n } from 'vue-i18n'
import elementLocale_zh_cn from 'element-plus/lib/locale/lang/zh-cn'
import elementLocale_en from 'element-plus/lib/locale/lang/en'

const messages = {
    'zh-cn': {
        name: "zh-cn", //在新版本中这个name不能没有，不然日历会报错
        el: elementLocale_zh_cn.el,
        common: {
            noAuth: "权限不足",
        },
        login: {
            title: '问题追踪解决知识库专家库云平台',
            username: '账号',
            password: '密码',
            usernameM: '账号：',
            passwordM: '密码：',
            usernameP: '请输入账号',
            passwordP: '请输入密码',
            login: '登 录',
            registry: '注 册',
            reset: '重 置',
            info: '还没有账号？点击',
            apply: '申请',
            aboutUs: '关于我们',
            contact: '联系我们',
            help: '帮助',
            copyRight: '版权所有：',
            compass: '上海指北电脑有限公司',
            notnull: '用户名不可为空',
            notnullp: '密码不可为空',
            welcomeToUse: '欢迎使用',
            issueInfo: 'issuebye问题追踪管理系统',
            applyAccount: '，请选择以下方式申请账号，并且根据系统提示完成操作！',
            tryUse: '试 用',
            applyFree: '申请免费账号',
            applyPay: '账号申请',
            applyFreeTitle: '申请免费账号',
            applyPayTitle: '申请付费账号',
            applyRole:"专家申请",
            sysInfo: '系统消息',
            sysInfoTry: '您可以使用该账号进入演示系统：',
            ifYouWant: '若您想成为',
            payAccountInfo: '的付费用户，请先通过邮箱或电话联系我们，我们将为您提供完备的系统功能，并且培训您使用本系统。',
            email: '邮箱',
            emailP : '请输入邮箱',
            contactWay: '联系方式',
            name: '姓名',
            nameP: '请输入姓名',
            save: '保存',
            loginS: '登录成功',
            usernameOrPasswordError: '用户名或密码错误',
            loginTm: '请完整输入账号和密码',
            registryS: '注册成功',
            loginInfo: '是否退出登录',
            account: '账户？',
            yes: '是',
            no: '否',
            s: '成功',
            logoutS: '成功退出登录',
            introducea:'云平台为用户提供3个角色: 客户，专家，普通管理员',
            introduceb:'客户用户可以提出问题、查看问题解决方案、查看知识库、了解能力域和价值链等；',
            introducec:'专家用户可以进入问题，提出问题的解决方案，创建知识库等；',
            introduced:' 普通管理员用户可以对公司员工进行管理维护，新增问题类型，维护问题状态等；',
            introducee:'如果您需要创建一个账号，您可以点击',
            introducef:'申请账号, 谢谢！ ',
            here: '这里',
        },
        contact: {
            contact: '联系我们',
            info1: '如果您有任何意见或建议，欢迎通过邮件或电话联系我们。同时，欢迎您到我们公司参观或走访，来访前请先与我们的客服人员联系，我们将安排工作人员接见您的到来，感谢您对issuebye的信任和支持！',
            workTime: '工作时间',
            tel: '客服热线: 153 5018 3115',
            telTime: '（上午 8:30--12：00 下午 13：00--17：30）',
            emailCallBack: '意见、建议反馈邮箱：issuebye@shcompass.com',
            bCororptation: '商务合作',
            charger: '负责人：刘先生',
            chargerTel: '联系电话：176 2157 6537',
            chargerEmail: '电子邮箱：sales@shcompass.com',
            service: '客户服务',
            charger2: '负责人：徐先生',
            charger2Tel: '联系电话：153 5018 3115',
            charger2Email: '电子邮箱：Oscar.xu@shcompass.com',
            pro: '产品咨询',
            backToLoginPage: '返回登录页',
        },
        help: {
            welcome: '欢迎使用问题处理云平台帮助中心',
            info1: 'Issuebye.com 是由上海指北电脑有限公司开发的一款问题记录、解决和跟踪云平台，可以帮助您构建解决处理问题的知识库，也可以使用该云平台中的已有的知识库。',
            info2: '您可以双击该图标或使用 www.issuebye.com 进入该平台为您设置的账号。',
            info3: '如需更多账号或者免费期后对账号续费，可以由贵公司管理员向上海指北有限公司销售人员联系，邮件：',
            salesEmail: 'sales@shcompass.com。',
            info4: '在页面有上角点击新增问题，在弹出的页面选择公司，在标题栏输入问题。',
            info5: ' 类型中选择问题类型，如无类型可选可以在新增类型中进行添加。',
            info6: ' 在内容中详细描述问题的内容，设置问题的优先级，优先级越高问题排列靠前，然后点击确定，主页面添加一条刚刚我们新增的记录。双击问题，屏幕右边弹出的新窗口会显示问题详情。问题内容可以根据问题的进展进行增加。在解决方案中填入问题处理的状态步骤，可以根据问题处理的节点填写。同时Issuebye.com云平台中还为您提供了共享文件和知识库使用。',
            info7: '如果您需要详细的操作手册，可以给Service@shcompass.com 发送请求邮件，我们的服务人员会发送最新的手册给您。',
            oprManul: '操作手册下载',
            tab2: '云平台操作规范',
            tab1: '云平台使用说明',
            tab3: '用户须知',
            tab4: '专注领域',
            info8: '电信和互联网用户个人信息保护规定',
            tip1: '第一条：',
            info9: '为了保护电信和互联网用户的合法权益，维护网络信息安全，根据《全国人民代表大会常务委员会关于加强网络信息保护的决定》、《中华人民共和国电信条例》和《互联网信息服务管理办法》等法律、行政法规，制定本规定。',
            tip2: '第二条：',
            info10: '在中华人民共和国境内提供电信服务和互联网信息服务过程中收集、使用用户个人信息的活动，适用本规定。',
            tip3: '第三条：',
            info11: '工业和信息化部和各省、自治区、直辖市通信管理局（以下统称电信管理机构）依法对电信和互联网用户个人信息保护工作实施监督管理。',
            tip4: '第四条：',
            info12: '本规定所称用户个人信息，是指电信业务经营者和互联网信息服务提供者在提供服务的过程中收集的用户姓名、出生日期、身份证件号码、住址、电话号码、账号和密码等能够单独或者与其他信息结合识别用户的信息以及用户使用服务的时间、地点等信息。',
            tip5: '第五条：',
            info13: '电信业务经营者、互联网信息服务提供者在提供服务的过程中收集、使用用户个人信息，应当遵循合法、正当、必要的原则。',
            tip6: '第六条：',
            info14: '电信业务经营者、互联网信息服务提供者对其在提供服务过程中收集、使用的用户个人信息的安全负责。',
            tip7: '第七条：',
            info15: '国家鼓励电信和互联网行业开展用户个人信息保护自律工作。',
            info16: '专注于为全球化商业领域的企业提供最优化的企业资源计划管理系统（ERP）、客户关系管理系统（CRM）、制造执行系统（MES）、企业资产管理系统（EAM）、供应链管理系统（SCM）、生产数据管理系统（PDM）、经销商管理系统（DMS）、金融行业软件（FIS）、商业智能（BI）、云计算和大数据（CMD）解决方案。',
        },
        home: {
            issue: '问题追踪解决知识库专家库云平台',
            tech: '技术支持：',
            agent: '代理商：',
            agentNone: '暂无',
            homePage: '个人主页',
            signOut: '退出登录',
            applyoutsider:'申请用户',
            newIssue: '新增问题',
            username: '用户名',
            contactUs: '联系我们：',
            sysEmail: '系统邮箱：',
            menu: {
                issueManage: '问题管理',
                issueView: '问题工作台',
                issueExport: '导出问题',
                newType: '问题类型',
                issueCharger: '问题负责人管理',

                expert: '专家管理',
                expertreview: '专家审核',
                expertall: '专家总览',

                sysM: '系统管理',
                om: '操作监控',
                fm: '文件管理',
                kb: '知识库',
                kbInfo: '知识库内容',
                kbType: '维护知识类别',
                kbM: '知识库管理',
                vc: '价值链',
                pd: '能力域',
                cm: '公司管理',
                mcm: '维护公司',
                muser: '用户管理',
                outsider:'审核用户',
                agentM: '代理商管理',
                magent: '维护代理商',
                serial: '序列号管理',
                serialReport: '打印序列号报表',
                dataPlatform: '数据平台',
                dataImport: '数据导入',
                dataExport: '数据导出',
                EDI: 'EDI',
                BOD: 'BOD',
                dataMig: '数据迁移',
                dataOpr: '数据传输',
                pcb:'采购成本分析',
                materialm:'材料单价',
                craftm:'工艺单价',
                purchasem:'采购计算',
                chatai:'AI答复',

            }
        },
        issue: {
            importNotify:'问题导入知识库提醒： ',
            importKbS: '导入成功',
            importKbF: '错误，解决方案不可为空',
            search: '请输入关键字搜索',
            kbInfo: '确定将此问题issue导入知识库审核, 是否继续?',
            success: '成功将一条issue导入知识审查',
            beCancel: '已取消',
            error: '出错了！',
            tips: '提示',
            fileInfo: '只能选取5个文件',
            fileAfterInfo: '请选择文件后再上传',
            uploadS: '上传成功',
            uploadF: '上传失败',
            importF: '文件导入失败',
            issueInfoNoFile: '该issue没有附件',
            deleteS: '删除成功',
            deleteF: '删除失败',
            confirmDelete: '确定移除此文件？',
            deleteFileInfo: '此操作将永久删除该文件, 是否继续?',
            addS: '新增成功',
            addF: '新增失败',
            plzUploadFile: '请上传问题文件',
            sameRe: '数据重复',
            issueFile: '问题附件',
            issueD: '请输入内容',
            deadLine: '预期完成时间',
            selectTime: '请选择一个时间',
            table: {
                customerInfo: '输入内容不允许有空格',
                id: '编号',
                urgency: '优先级',
                issueId: '问题编号',
                company: '公司',
                title: '标题',
                type: '类型',
                customer: '客户',
                submitTime: '提交时间',
                cus: '负责人:',
                status: '当前状态',
                opr: '操作',
                issueTrack: '问题追踪',
                createTime: '创建时间：',
                issueContent: '问题内容:',
                solution: '解决方案:',
                remark: '备注:',
                resFile: '回复文件',
                fileName: '文件名',
                path: '问题路径',
                download: '下载',
                contentD: '请输入问题内容',
                solutionD: '请输入解决方案',
                remarkD: '请输入备注',
                companyD: '请选择问题所属公司',
                titleD: '请输入',
                typeD: '请选择问题类型',
                customerD: '请选择或输入客户姓名',
                delete: '删除',
                fileC: '选取文件',
                upServer: '上传到服务器',
                customerDD: '请输入客户',
                exportKb: '导入知识库',
                getrecommmended: '寻求专家建议',
                newIssue: '新建问题',
                uploadFile: '附件上传：',
                confirm: '确 定',
                cancel: '取 消',
                importKBBag: '导入知识库审核列表',
                importKBTips: '请先选择合适的知识类别',
                chargeTime: '收费时长:',
                // chargeTimeD: '请输入收费时长，以小时为单位',
                chargeTimeD: '请输入',
                hours: '小时',
                engineer: '创建人：',
                deadLine: '预期完成时间：',
                statusTips:'状态:',
                statusClose:'关闭',
                statusOpen: '开启',
                statusCancel:'取消',
                issuesolu:'问题详情',
            }
        },
        issueTrack: {
            title: '标题：',
            dialog: '对话栏',
            content: '内容：',
            reply: '回复：',
            replyPerson: '对话人：',
            crp: '请选择回复用户',
            rc: '回复：',
            em: '邮件提醒：',
            norm: '不提醒',
            rm: '提醒一下',
            sd: '发送对话',
            rs: '重置',
            home: '返回主页',
            uploadInfo: '上传问题文件，且不超过8MB',
            onlyImg: '只能上传图片！',
            issueImage:'问题截图: ',
            uploadImage:'上传文件:',
            uploadClick:'点击上传文件',
            responseText:'请填写回复内容',
            emailAccountMsg:'对话人暂无邮箱账户',
            successMsg:'回复成功！',
            errMsg:'出错了！',
            remind:'是否提醒',
            alerted:'已提醒',
        },
        expert: {
            importNotify:'问题导入知识库提醒： ',
            importKbS: '导入成功',
            importKbF: '错误，解决方案不可为空',
            search: '请输入关键字搜索',
            kbInfo: '确定将此问题issue导入知识库审核, 是否继续?',
            success: '成功将一条issue导入知识审查',
            beCancel: '已取消',
            error: '出错了！',
            tips: '提示',
            fileInfo: '只能选取5个文件',
            fileAfterInfo: '请选择文件后再上传',
            uploadS: '上传成功',
            uploadF: '上传失败',
            importF: '文件导入失败',
            issueInfoNoFile: '该issue没有附件',
            deleteS: '删除成功',
            deleteF: '删除失败',
            confirmDelete: '确定移除此文件？',
            deleteFileInfo: '此操作将永久删除该文件, 是否继续?',
            addS: '新增成功',
            addF: '新增失败',
        },
        exportIssue: {
            company: '公司',
            companyS: '请选择问题所属公司',
            section: '区间',
            to: '至',
            sDate: '开始日期',
            eDate: '结束日期',
            export: '导出',
            exportInfo: '确定导出此公司issues？',
            confirm: '确定',
            cancel: '取消',
            mention: '提示',
            companyD: '请选择公司',
            dateD: '请选择日期',
        },
        addType: {
            company: '公司',
            companyS: '请选择问题所属公司',
            type: '问题类型',
            typeS: '请输入添加的问题类型',
            confirm: '确 定',
            cancel: '取 消',
            id: '编号',
            typeName: '类型名称',
            typeDisable:'禁用状态',
            disable:'禁用',
            enable:'启用',
            successtips:'状态已更新',
            opr: '操作',
            companyD: '请选择公司',
            info: '此操作将永久删除该问题类型，原有该问题类型的问题需要手动去修改否则无法删除, 是否继续?',
            existOtherIssue: '还存在该类型的问题，无法删除',

        },
        charger: {
            search: '输入关键字搜索',
            new: '新增负责人',
            table: {
                charger: '负责人',
                chargeCompany: '负责公司',
                type: '问题类型',
                opr: '操作',
            },
            delete: '删除',
            companyInCharge: '请选择负责公司',
            personInCharge: '请选择负责人',
            typeS: '请选择问题类型',
            create: '立即创建',
            reset: '重置',
            info: '输入信息不存在',
        },
        OM: {
            search: '输入关键字搜索',
            select: '请选择',
            table: {
                user: '操作用户',
                ip: '登陆IP',
                broswer: '浏览器',
                os: '操作系统',
                oprTime: '操作时间',
                oprDetail: '操作详情',
            }
        },
        kbinfo:{
            newKbk: '新建知识',
            newKb: '新建知识库',
            kbList: '知识库列表',
            kbTitle: '知识标题',
            issueT: '问题标题',
            issueTD: '请输入问题标题...',
            themeD: '请填写主题',
            kbType: '知识类别',
            kbTypeD: '请选择知识类别',
            solution: '解决方案',
            solutionD: '请输入解决方案',
            createNow: '立刻创建',
            reset: '重置',
            keyword: '关键词：',
            keywordD: '请输入关键词',
            select: '查询',
            newKbD: '创建一条待审核知识',
            no: '未分类',
            casKbCat: '级联知识类别',
            table: {
                id: '编号',
                title: "标题",
                kbType: '知识类别',
                time: '完成时间',
            },
            kbDetail: '知识详情',
            solutionm: '解决方案：',
            updateTime: '更新时间：',
            newtips:'此操作将创建一条知识, 是否继续?',
            calcelnew:'已取消创建',
            kbInfoD: '知识内容不可为空',
            kbTitleD: '请输入知识标题',
            creator:'创建人:',
        },
        kbType: {
            newKbType: '增加知识类别',
            kbType: '知识类别',
            creator: '创作者',
            tag:'标签',
            id: '编号',
            mKbType: '新增知识类别',
            editKBType:'维护知识类别',
            parentTip:'请选择父类别',
            cancel: '取消',
            kbTypeD: '请输入知识类型',
            lengthD15: '长度在 1 到 15 个字符之间',
            lengthD8: '长度在 1 到 8 个字符之间',
            creatorD: '请输入创作者',
            newKbS: '成功新增一条知识类别',
            newKbF: '添加失败',
            typeParentName:'父类别',
            update:'更新',
            addTag:'添加标签',
            createTime:'创建时间',
            parentTips:'请选择或创建父类别',
            TypeParentTips: '请输入父类型',
        },
        valueChain: {
            newV: '新增价值链',
            vcId: "价值链编号",
            fvcId: "父价值链编号",
            content: '内容',
            vcIdD: '价值链编号只能包含数字和英文半角横线',
            fvcIdD: '父价值链编号会自动生成',
            contentD: '请输入价值链内容',
            new: '新增',
            cancel: '取消',
            vcIdP: '请输入价值链编号',
            contentP: '请输入价值链内容',
            companyP: '请输入公司名称',
            info: '只能输入数字和英文半角横线，例如A-010-010',
        },
        powerDomain: {
            newP: '新增能力域',
            deleteP: '删除能力域',
            pId: '能力域编号',
            fpId: '父能力域编号',
            title: '标题',
            cross: '跨级别设置',
            pIdD: '能力域编号只能包含数字和小数点',
            fpIdD: '父能力域编号会自动生成，如需手工维护请开启跨级别设置',
            titleD: '请输入能力域标题',
            deleteUpDown: '同时删除上下级关系',
            d: '删除',
            place: '请选择',
            pIdP: '请输入能力域编号',
            info: '只能输入数字和小数点',
        },
        kbReview: {
            kbR: '知识库审核',
            review: '审核',
            toBeReview: '待审核',
            pass: '审核通过',
            recycle: '回收站',
            delete: '删除',
            reviewNoPass: '审核不通过',
            kbTypeD: '请填写知识类别',
            solutionD: '请填写解决方案',
            reviewD: '请选择审核状态',
            reviewS: '审核完成',
            deleteD: '此操作将永久删除该知识, 是否继续?',
            deleteMater:'此操作将永久删除该材料信息, 是否继续?',
            deleteTag:'此操作将永久删除该标签, 是否继续?',
            toBeApproved: '回退至审核状态, 是否继续?',
            approveS: '成功回退至待审核状态',
            approveF: '回退失败',
            table: {
                id: '编号',
                title: '标题',
                kbType: '知识类别',
                solution: '解决方案',
                createTime: '创建时间',
                selecttag:'请选择标签',
                opr: '操作',
            },
            theme: '主题',
            approve: '审核',
            backToApprove: '回退至待审核',
            kbRecycle: '知识库回收站',
        },
        company: {
            new: '新增公司',
            companyName: '公司名称',
            companyIden: '公司简称',
            confirm: '立刻创建',
            reset: '重置',
            id: '编号',
            delete: '删除',
            opr: '操作',
            companyNameD: '请输入公司名称',
            companyIdenD: '请输入公司简称',
            comlinitlen:'长度在 1 到 12 个字符',
            idenlimitlen:'长度在 3 到 8 个字符',
            info: '此操作将永久删除该公司, 是否继续?',
            deleteS: '删除失败，该公司还有其他用户！',
        },
        user: {
            selectRole: '请选择角色',
            selectD: '请选择公司',
            new: '新增用户',
            id: '编号',
            username: '用户名',
            usernameD: '请输入用户名（登陆）',
            email: '邮箱',
            emailD: '请输入邮箱',
            realname: '姓名',
            realnameD: '请输入真实姓名',
            role: '角色',
            roleD: '请选择用户角色',
            company: '公司',
            companyD: '请选择用户所属公司',
            opr: '操作',
            usernameLogin: '用户名',
            password: '密码',
            passwordD: '请输入用户密码（登陆）',
            newCompany: '新增公司',
            createNow: '立即创建',
            reset: '重置',
            updateUser: '修改用户-',
            update: '修改',
            cancel: '取消',
            roleM: '角色：',
            delete: '删除',
            emailP: '请输入正确的邮箱格式',
            lengthD150: '长度在 1 到 50 个字符',
            lengthD615: '长度在 6 到 15 个字符',
            lengthD115: '长度在 1 到 15 个字符',
            info: '此操作将禁用该用户, 是否继续?',
            updateS: '修改成功',
            insertS: '插入成功',
            inserterrUN:'添加失败，用户名已存在！',
            inserterrN:'添加失败，姓名已存在！',
            auth: '授权',
            save: '保存',
            deleteAdmin: 'admin不可被删除',
            deleteSelf: '不可删除自己',
            banUser: '禁用',
        },
        agent: {
            select: '请输入关键字搜索',
            selectM: '请选择',
            id: '代理商编号',
            name: '代理商名称',
            companyName: '代理公司名称',
            contact: '代理商联系方式',
            logo: '代理商Logo',
            opr: '操作',
            new: '新增代理商',
            idD: '请输入代理商编号',
            nameD: '请输入代理商名称',
            companyNameD: '请选择代理公司',
            contactD: '请输入代理商联系方式',
            uploadD: '文件拖入或 ',
            uploadLink: '点击上传',
            info: 'png 文件大小限制2MB',
            logoD: '请上传代理商Logo',
            lengthD120: '长度在 1 到 20 个字符',
            lengthD510: '长度在 5 到 10 个字符',
            lengthD7: '长度在 7 个字符',
            imageD: '上传图片只能是 PNG 格式',
            imageSizeD: '上传图片大小不能超过 2MB',
            deleteDF: '此操作将永久删除该记录, 是否继续?',
            onlyNum: '请输入有效的中国手机号码',
            sameRow: '数据已存在',
            btn: {
                new: '新增',
                cancel: '取消',
                delete: '删除'
            }
        },
        applyoutsider:{
            username:'用户名',
            role:'用户身份',
            password:'密码',
            email:'邮箱',
            companyName:'公司名',
            name:'姓名',
            tipsrole:'请选择用户角色',
            applysucc:'注册成功，待管理员审核',
            tipsusername:'请输入用户名',
            tipspassword:'请输入密码',
            tipsemail:'请输入邮箱',
            tipscompanyname:'请输入公司/部门 名',
            tipsname:'请输入你的真实姓名',
            opexpert:'专家',
            opuser:'普通管理员',
            customer:'客户',
            applytips:'申请说明',
            cert:'资质证书',
            resume:'个人简历',
            inputapply:'请输入申请说明',
            accountapply:'专家申请',
        },
        mangeroutsider:{
            id:'编号',
            username:'用户名',
            password:'密码',
            name:'姓名',
            email:'邮箱',
            companyName:'公司名',
            role:'角色',
            ispass:'状态',
            customer:'客户',
            outsider:'普通管理员',
            expert:'专家',
            passto:'审核通过',
            passun:'未审核',
            passno:'审核不通过',
            createTime:'创建时间',
            auditusers:'用户审核',
            applyinstruction:'申请介绍',
            attachment:'附件表',
            filename:'文件名',
            filetype:'文件类型',
            userRole:'用户角色',
            passstatus:'审核状态',
            calcel:'取消',
            sure:'确定',
            inputuserrole:'请选择用户身份',
           
        },

        reviewexpertstatus:{
            id:'编号',
            username:'用户名',

            name:'姓名',
            email:'邮箱',
            isExpert:'状态',
            customer:'客户',
            outsider:'普通管理员',
            expert:'专家',
            passto:'审核通过',
            passun:'未审核',
            passno:'审核不通过',
            createTime:'创建时间',
            auditusers:'用户审核',
            applyinstruction:'申请介绍',
            attachment:'附件表',
            filename:'文件名',
            filetype:'文件类型',
            // userRole:'用户角色',
            passstatus:'审核状态',
            calcel:'取消',
            sure:'确定',
            phonenumber:'电话',
            registrytime:'注册时间',
            specialization:'专业领域',
            location:'地点',
            profileimage:'头像',
           
        },
        serialReport:{
            from: '自',
            to: '至',
            printBtn: '打印',
            resetBtn: '重置',
            projectCode: '项目号',
            itemCode: '物料号',
            serialNumber: '序列号',
            salesOrderNumber: '销售订单号',
            deliveryDate: '发运日期',
            invoiceNumber: '发票号',
            invoiceDate: '开票日期',
        },
        auth: {
            authIssueTypeTitle: '用户问题类型授权',
            authIssueTypeUsername: '用户名',
            authIssueTypeCompany: '公司',
            authIssueType: '问题类型',
        },
        material:{
            addmaterial:'添加材料信息',
            id:'编号',
            materialcode:'材料代码',
            material:'材料',
            materialprice:'材料单价',
            unit:'单位',
            add:'新增',
            updatematerial:'修改材料信息',
            inmctips:'请输入材料代码',
            inmtips:'请输入材料名称',
            inmptips:'请输入材料单价',
            inmutips:'请输入材料单价单位',
            mtype:'材料类别',
            imtype:'请选择或新建材料类别',
            inctips:'请选择币种',
            addoktips:'添加成功',
            adderrtips:'添加失败',
            updateoktips:'更新成功了！',
            updateerrtips:'更新失败',
        },
        craft:{
            addcraft:'添加工艺信息',
            id:'编号',
            craftcode:'工艺代码',
            craftdesc:'工艺描述',
            craftprice:'工艺单价',
            unit:'单位',
            createTime:'创建时间',
            updateTime:'更新时间',
            updatecraft:'修改工艺信息',
            incctips:'请输入工艺代码',
            incdtips:'请输入工艺描述',
            incptips:'请输入工艺单价',
            incutips:'请输入工艺单价单位',
        },
        purchase:{
            tomaterial:'请选择材料',
            materialMultip:'材料系数',
            tomMultiplier:'请输入材料质量参数',
            craftnotnull:'工序不能为空',
            mmnotnull:'工艺系数不能为空',
            tocraft:'请选择工艺工序',
            craftMult:'工艺系数',
            incmult:'请输入工序系数',
            inmmult:'请输入材料系数',
            totalcost:'成本总计:',
            craft:'工序',
            lossFactor:'损耗系数',
            inputloss:'请输入损耗系数',
            manageMultip:'管理费比例',
            inputManage:'请输入管理费比例',
            feeList:'成本详情: ',
            cmFee:'材料工艺成本:',
            manageFee:'管理费: ',
            pcblist:'采购成本清单:',
            inlnotnull:'损耗系数不为空',
            inwnotnull:'材料系数不为空',
            deleteHtips:'此操作将永久删除该信息, 是否继续?',
            exportpcb:'导出历史数据',
        },
        chatai:{
            chatai:'AI答复',
            chatroom:'聊天界面',
            inputchat:'请输入您需要了解的问题',
            fqa:'常见问题解答',
            q1:'你好,你能做什么？',
            a1:'您好,作为一个AI助手,我可以在语言与翻译、日常生活、时事与新闻、学术与教育、编程与开发等许多方面为你提供解答和帮助!',
        }


        
    },
    'en': {
        name: "en",
        el: elementLocale_en.el,
        common: {
            noAuth: "No authorization",
        },
        login: {
            title: 'IssueBye Cloud Platform ',
            username: 'Username',
            password: 'Password',
            usernameM: 'Username:',
            passwordM: 'Password:',
            usernameP: 'Please Enter Your Username',
            passwordP: 'Please Enter Your Password',
            login: 'Login',
            registry: 'Apply',
            reset: 'Reset',
            info: 'Haven\'t an account yet? Click to ',
            apply: 'apply',
            aboutUs: 'About Us',
            contact: 'Contact Us',
            help: 'Help',
            copyRight: 'Copy Right ',
            compass: ' Shanghai Compass Computer Co., Ltd.',
            notnull: 'The user name cannot be empty',
            notnullp: 'The password cannot be empty',
            welcomeToUse: 'Welcome to use ',
            issueInfo: 'Issuebye Issue Tracking Management System',
            applyAccount: ', Please select the following buttons to apply for an account, and follow the system prompts to complete the operation!',
            tryUse: 'On Probation',
            applyFree: 'Apply For An Free Account',
            applyPay: 'Apply For An Account',
            applyFreeTitle: 'Apply for a free account',
            applyPayTitle: 'Apply for a paid account',
            applyRole:"Expert application",
            sysInfo: 'System Message',
            sysInfoTry: 'You can use this account to access the demo system:',
            ifYouWant: 'If you want to become a paid user of ',
            payAccountInfo: ', please contact us by email or phone first, we will provide you with complete system features and train you to use this system.',
            email: 'Email',
            emailP: 'Please Enter Your Email',
            contactWay: 'Contact information',
            name: 'Name',
            nameP: 'Please Enter Your Name',
            save: 'Save',
            loginS: 'Login successful',
            usernameOrPasswordError: 'Incorrect username or password',
            loginTm: 'Please enter your username and password completely',
            registryS: 'Regsitered successfully',
            loginInfo: 'Do you want to log out of the ',
            account: ' account?',
            yes: 'Yes',
            no: 'No',
            s: 'successfully',
            logoutS: 'Logout successfully',
            introducea:'The cloud platform provides users with 3 roles: Customer, Expert, and Administrator',
            introduceb:'Customer users can ask questions, view problem solutions, view knowledge bases, understand capability areas and value chains, and more.',
            introducec:'Expert users can enter problems, propose solutions to problems, create knowledge bases, etc.',
            introduced:'Administrators can manage and maintain the employees, add new problem types, maintain problem status, etc. ',
            introducee:'If you need to create an account, click  ',
            introducef:'to apply an account, Thanks!',
            here: 'here',
        },
        contact: {
            contact: 'Contact Us',
            info1: 'If you have any comments or suggestions, please contact us by email or phone. At the same time, you are welcome to visit our company or visit, please contact our customer service staff before visiting, we will arrange staff to meet your arrival, thank you for your trust and support!',
            workTime: 'Working Hours',
            tel: 'Service hotline: 153 5018 3115',
            telTime: '(8:30 am -- 12:00 PM -- 13:00 PM -- 17:30 PM)',
            emailCallBack: 'Feedback Email: issuebye@shcompass.com',
            bCororptation: 'Business Cooperation',
            charger: 'Person in charge: Mr. Liu',
            chargerTel: 'Contact number: 176 2157 6537',
            chargerEmail: 'E-mail: sales@shcompass.com',
            service: 'Customer Service',
            charger2: 'Person in charge: Mr. Xu',
            charger2Tel: 'Contact number: 153 5018 3115',
            charger2Email: 'E-mail: Oscar.xu@shcompass.com',
            pro: 'Product Consulting',
            backToLoginPage: 'Return to Login page',
        },
        help: {
            welcome: 'Welcome to the Troubleshooting Cloud Platform Help Center',
            info1: 'Issuebye.com is a cloud platform for problem recording, resolution and tracking developed by Shanghai Zhibei Computer Co., LTD., which can help you build a knowledge base for solving and processing problems, or you can use the existing knowledge base in the cloud platform.',
            info2: 'You can double-click the icon or use www.issuebye.com to access the account that the platform has set up for you.',
            info3: 'If you need more accounts or renew your account after the free period, you can contact the sales staff of Shanghai Compass Co., LTD., by email:',
            salesEmail: 'sales@shcompass.com.',
            info4: 'Click Add Issue in the top corner of the page, select the company on the pop-up page, and enter the question in the title bar.',
            info5: ' Type Select the problem type. If no type is optional, you can add the problem type in the new type.',
            info6: ' Describe the contents of the problem in detail in the content, set the priority of the problem, the higher the priority of the problem, and then click OK to add a record that we just added on the main page. Double-click on the problem and a new window pops up on the right side of the screen showing the problem details. The content of the question can be increased according to the progress of the question. In the solution, fill in the status steps for problem processing, depending on the node where the problem is being processed. At the same time, Issuebye.com cloud platform also provides you with shared files and knowledge base.',
            info7: 'If you need a detailed manual, you can send a request to Service@shcompass.com and our support staff will send you the latest one.',
            oprManul: 'Operation manual download',
            tab2: 'Cloud platform operation specifications',
            tab1: 'Cloud platform usage',
            tab3: 'User notice',
            tab4: 'Focus area',
            info8: 'Regulations on the protection of personal information of telecommunications and Internet users',
            tip1: 'Article 1:',
            info9: 'In order to protect the legitimate rights and interests of telecommunications and Internet users and maintain network information security, these Provisions are formulated in accordance with the Decision of the Standing Committee of the National People\'s Congress on Strengthening Network Information Protection, the Telecommunications Regulations of the People\'s Republic of China and the Measures for the Administration of Internet Information Services and other laws and administrative regulations.',
            tip2: 'Article 2:',
            info10: 'These Provisions shall apply to the activities of collecting and using users\' personal information in the course of providing telecommunications services and Internet information services within the territory of the People\'s Republic of China.',
            tip3: 'Article 3:',
            info11: 'The Ministry of Industry and Information Technology and the Communications Administration of all provinces, autonomous regions and municipalities directly under the Central Government (hereinafter referred to as the telecommunications regulatory authorities) shall supervise and administer the protection of personal information of telecommunications and Internet users according to law.',
            tip4: 'Article 4:',
            info12: 'The term "user personal information" as used in these Provisions refers to the user\'s name, date of birth, ID card number, address, telephone number, account number and password collected by telecom business operators and Internet information service providers in the course of providing services, which can identify users individually or in combination with other information, and the user\'s time and place of using services.',
            tip5: 'Article 5:',
            info13: 'Telecommunications business operators and Internet information service providers shall, in the process of providing services, collect and use users\' personal information in accordance with the principles of legality, legitimacy and necessity.',
            tip6: 'Article 6:',
            info14: 'Telecommunications business operators and Internet information service providers shall be responsible for the security of users\' personal information collected and used in the course of providing services.',
            tip7: 'Article 7:',
            info15: 'The State encourages the telecommunications and Internet industries to self-regulate the protection of users\' personal information.',
            info16: 'Focus on the global business field of enterprise resource planning management system (ERP), customer relationship management system (CRM), manufacturing execution system (MES), enterprise Asset management system (EAM), Supply chain management system (SCM), production data management system (PDM), dealer management system (DMS), financial industry Software (FIS), Business Intelligence (BI), Cloud computing and Big Data (CMD) solutions.',
        },
        home: {
            issue: 'IssueBye Cloud Platform',
            tech: 'Technical support:',
            agent: 'Agent:',
            agentNone: 'None',
            homePage: 'Personal Homepage',
            signOut: 'Sign Out',
            applyoutsider:'Apply user',
            newIssue: 'New Issue',
            contactUs: 'Contact us: ',
            sysEmail: 'System email: ',
            username: 'Username',
            menu: {
                issueManage: 'Issue Management',
                issueView: 'Issues Workbench',
                issueExport: 'Export Issues',
                newType: 'Issue Type',
                issueCharger: 'Issue Managers Management',
                sysM: 'System Management',
                om: 'Operation Monitoring',
                fm: 'Files Management',
                kb: 'Knowledge Base',
                kbInfo: 'Knowledge Base Contents',
                kbType: 'Maintain Knowledge Categories',
                kbM: 'Knowledge Base Management',
                vc: 'Value Chains',
                pd: 'Capability Domain',
                cm: 'Company Management',
                mcm: 'Maintain Companies Info',
                muser: 'User Management',
                outsider:'Maintain Experts Info',
                agentM: 'Agents Management',
                magent: 'Maintain Agents Info',
                serial: 'Serial Management',
                serialReport: 'Print Serial Report',
                dataPlatform: 'Data Platform',
                dataImport: 'Data Import',
                dataExport: 'Data Export',
                EDI: 'EDI',
                BOD: 'BOD',
                dataMig: 'Data Migration',
                dataOpr: 'Data Transfer',
                pcb:'PCB',
                materialm:'Material Management',
                craftm:'Process Management',
                purchasem:'Procurement Calculation',
                chatai:'ChatAI',
            }
        },
        issue: {
            importNotify:'Reminder for importing issue into the knowledge base：',
            importKbS: 'Successfully Imported',
            importKbF: 'Error, the solution is empty',
            search: 'Please enter a keyword to search',
            kbInfo: 'Confirm to import this issue into the Knowledge base audit, do you want to continue?',
            success: 'Successfully imported an issue into knowledge review',
            beCancel: 'Cancelled',
            error: 'Error!',
            tips: 'Tips',
            fileInfo: 'Only 5 files can be selected',
            fileAfterInfo: 'Please select the file and upload it',
            uploadS: 'Upload success',
            uploadF: 'Upload failure',
            importF: 'File import failure',
            issueInfoNoFile: 'This issue has no attachment',
            deleteS: 'Successfully deleted',
            deleteF: 'Deletion failure',
            confirmDelete: 'Confirm to remove this file?',
            deleteFileInfo: 'This operation will delete the file permanently. Do you want to continue?',
            addS: 'Add success',
            addF: 'Add failure',
            plzUploadFile: 'Please upload the issue\'s file',
            sameRe: 'Data duplication', 
            issueFile: 'Issue attachment',
            issueD: 'Please enter content',
            deadLine: 'Expected completion time',
            selectTime: 'Please select a time',
            table: {
                customerInfo: 'The input content cannot contain Spaces',
                customerDD: 'Please enter the customer\'s name ',
                id: 'ID',
                urgency: 'Priority',
                issueId: 'Issue ID',
                company: 'Company',
                title: 'Title',
                type: 'Type',
                customer: 'Customer',
                submitTime: 'Submit Time',
                cus: 'Person In Charger',
                status: 'Status',
                opr: 'Operation',
                issueTrack: 'Issue Track',
                createTime: 'Creation time:',
                issueContent: 'Content:',
                solution: 'Solution:',
                remark: 'Remarks:',
                resFile: 'Response files',
                fileName: 'File Name',
                path: 'Path',
                download: 'Download',
                contentD: 'Please enter the issue\'s content',
                solutionD: 'Please enter the issue\'s solution',
                remarkD: 'Please enter remarks',
                companyD: 'Please choose a company of your issue',
                titleD: 'Please enter ',
                typeD: 'Please choose a type of your issue',
                customerD: 'Please select or enter the customer name',
                delete: 'Delete',
                fileC: 'Choose File',
                upServer: 'Upload To Server',
                exportKb: 'Export To Knowledge Base',
                getrecommmended: 'Seek Expert Advice',
                newIssue: 'New Issue',
                uploadFile: 'Attachment upload',
                confirm: 'Confirm',
                cancel: 'Cancel',
                importKBBag: 'Import Knowledge Base ',
                importKBTips: 'Please select an appropriate knowledge category first.',
                chargeTime: 'Fee duration:',
                chargeTimeD: 'Please enter ',
                // chargeTimeD: 'Please enter the charge time, in hours',
                hours: 'Hours',
                engineer: 'Creator: ',
                deadLine: 'Expected completion time: ',
                statusTips:'Status:',
                statusClose:'Close',
                statusOpen: 'Open',
                statusCancel:'Cancel',
                issuesolu:'Details of the Issue',
            }
        },
        issueTrack: {
            title: 'Title: ',
            dialog: 'Dialog Box',
            content: 'Content: ',
            reply: 'Reply: ',
            replyPerson: 'Interlocutor: ',
            crp: 'Please select a reply user',
            rc: 'Reply content:',
            em: 'Email reminder: ',
            norm: 'Not remind',
            rm: 'Remind',
            sd: 'Send Conversation',
            rs: 'Reset',
            home: 'Home',
            uploadInfo: ' can be uploaded, and the file should not exceed 8MB',
            onlyImg: 'Only images can be uploaded!',
            issueImage:'Problem Picture:',
            uploadImage:'Upload file: ',
            uploadClick:'Click To Upload',
            responseText:'Please fill in the details of your reply',
            emailAccountMsg:'The interlocutor does not have an email account',
            successMsg:'The reply was successful！',
            errMsg:'error..!',
            remind:'remind',
            alerted:'Alerted',

        },
        exportIssue: {
            company: 'Company',
            companyS: 'Choose a company to which the issue belongs',
            section: 'Section',
            to: 'To',
            sDate: 'Start Date',
            eDate: 'End Date',
            export: 'Export',
            exportInfo: 'Are you sure to export this company issue?',
            confirm: 'Confirm',
            cancel: 'Cancel',
            mention: 'Tips',
            companyD: 'Please select a company',
            dateD: 'Please select a date',
        },
        addType: {
            company: 'Company',
            companyS: 'Choose a company to which the type belongs',
            type: 'Issue Type',
            typeS: 'Please enter a type of issues',
            confirm: 'Confirm',
            cancel: 'Cancel',
            id: 'ID',
            typeName: 'Type Name',
            typeDisable:'Disabled Status',
            disable:'Disable',
            enable:'Enable',
            successtips:'The status has been updated',
            opr: 'Operation',
            companyD: 'Please select a company',
            info: 'This operation will permanently delete the issue type. You need to manually modify the existing issue type. Do you want to continue?',
            existOtherIssue: 'This type of issues still exists and cannot be deleted',
        },
        charger: {
            search: 'Enter a keyword to search',
            new: 'Add Person In Charge',
            table: {
                charger: 'Person In Charge',
                chargeCompany: 'Company',
                type: 'Issue Type',
                opr: 'Operation',
            },
            delete: 'Delete',
            companyInCharge: 'Please select the responsible company',
            personInCharge: 'Please select the person in charge',
            typeS: 'Please select a issue type',
            create: 'Create Now',
            reset: 'Reset',
            info: 'the input information does not exist',
        },
        OM: {
            search: 'Enter a keyword to search',
            select: 'Please select',
            table: {
                user: 'Operating User',
                ip: 'Login IP',
                broswer: 'Browser',
                os: 'Operating System',
                oprTime: 'Operating Time',
                oprDetail: 'Operation Details',
            }
        },
        kbinfo: {
            newKbk: 'Create Knowledge',
            newKb: 'Create Knowledge',
            kbTitle: 'Knowledge Title',
            kbList: 'Knowledge Base List',
            issueT: 'Issue Title',
            themeD: 'Please enter a issue title',
            issueTD: 'Please enter a issue title',
            kbType: 'Knowledge Type',
            kbTypeD: 'Please select a knowledge category',
            solution: 'Solution',
            solutionD: 'Please enter the solution',
            createNow: 'Create Now',
            reset: 'Reset',
            keyword: 'Keyword',
            keywordD: 'Enter a keyword to search',
            select: 'Select',
            newKbD: 'Creates a piece of knowledge to be approved',
            no: 'Not classified',
            casKbCat: 'Cascade Knowledge Categories',
            table: {
                id: 'ID',
                title: "Title",
                kbType: 'Knowledge Type',
                time: 'Finish Time',
            },
            kbDetail: 'Knowledge Detail',
            solutionm: 'Solution: ',
            updateTime: 'Update Time: ',
            newtips:'This will create a piece of knowledge, do you want to continue?',
            calcelnew:'The creation has been canceled',
            kbInfoD: 'The knowledge content cannot be empty',
            kbTitleD: 'Please enter a knowledge title',
            creator:'Creator:',
        },
        kbType: {
            newKbType: 'Add Knowledge Category',
            kbType: 'Knowledge Category',
            creator: 'Creator',
            tag:'Tag',
            id: 'ID',
            mKbType: 'Add Knowledge Category',
            editKBType:'Maintain Knowledge Categories',
            parentTip:'Please select a parent category',
            cancel: 'Cancel',
            kbTypeD: 'Please enter a knowledge category',
            lengthD15: 'The length is between 1 and 15 characters',
            lengthD8: 'The length is between 1 and 8 characters',
            creatorD: 'Please enter Creator',
            newKbS: 'A knowledge category is successfully added',
            newKbF: 'Add failure',
            typeParentName:'Parent Category',
            update:'Update',
            addTag:'Add Tags',
            createTime:'Creation Time',
            parentTips:'Please select or create a parent category',
            TypeParentTips:'Please enter a parent category',
        },
        valueChain: {
            newV: 'Maintain Value Chain',
            vcId: "Value Chain ID",
            fvcId: "Parent Value Chain ID",
            content: 'Content',
            vcIdD: 'Value chain numbers can only contain numbers and English half-corner symbols',
            fvcIdD: 'The parent value chain number is automatically generated',
            contentD: 'Please enter value chain content',
            new: 'Confirm',
            cancel: 'Cancel',
            vcIdP: 'Please enter value chain ID',
            contentP: 'Please enter value chain\'s content',
            companyP: 'Please enter a company name',
            info: 'Only digits and English half-corner lines can be entered, for example, A-010-010',
        },
        powerDomain: {
            newP: 'Maintain Capability Domain',
            deleteP: 'Delete Capability Domain',
            pId: 'Capability Domain ID',
            fpId: 'Parent Capability Domain ID',
            title: 'Title',
            cross: 'Cross-Level Setup',
            pIdD: 'Power domain id can only contain numbers and decimal points',
            fpIdD: 'The parent domain number is automatically generated. If manual maintenance is required, choose cross-level',
            titleD: 'Please enter a capability domain title',
            deleteUpDown: 'Delete the relationship between superiors and subordinates',
            d: "Delete",
            place: 'Select',
            pIdP: 'Please enter a capability domain ID',
            info: 'Only numeric decimal points can be entered',
        },
        kbReview: {
            kbR: 'Knowledge base approve',
            review: 'To be approved',
            pass: 'Approved',
            recycle: 'Recycle bin',
            delete: 'Delete',
            kbTypeD: 'Please fill in the knowledge category',
            solutionD: 'Please fill in the solution',
            reviewD: 'Please select review status',
            reviewS: 'Successful approved',
            deleteD: 'This action permanently deletes the knowledge',
            deleteMater:'This action permanently deletes the material?',
            deleteTag:'This action permanently deletes the tag',
            toBeApproved: 'Go back to approve. Do you want to continue?',
            approveS: 'Successfully rolled back to the pending approve state',
            approveF: 'Rollback failure',
            toBeReview: 'To be Review',
            table: {
                id: 'ID',
                title: 'Title',
                kbType: 'KB Category',
                solution: 'Solution',
                createTime: 'Creation Time',
                selecttag:'Please select a tag',
                opr: 'Operation',
            },
            theme: 'Title',
            reviewNoPass: 'Fail to approve',
            approve: 'Approve',
            backToApprove: 'Back To Approval',
            kbRecycle: 'Knowledge base recycle bin'
        },
        company: {
            new: 'Add Company',
            companyName: 'Company Name',
            companyIden: 'Short Name',
            confirm: 'Create Now',
            reset: 'Reset',
            id: 'ID',
            delete: 'Delete',
            opr: 'Operation',
            companyNameD: 'Please enter a name of your company',
            companyIdenD: 'Please enter a short name of your company',
            comlinitlen:'Length: 1 to 12 characters',
            idenlimitlen:'Length: 3 to 8 characters',
            info: 'This action will permanently delete the company, do you want to continue? ',
            deleteS: 'Deletes fail, the company has other users!',
        },
        user: {
            selectRole: 'Please select a role for the user',
            selectD: 'Please select a company',
            new: 'Add User',
            id: 'ID',
            password: 'Password',
            passwordD: 'Please enter user\'s password(login)',
            username: 'Username',
            usernameD: 'Please enter username(login)',
            email: 'Email',
            emailD: 'Please enter the user\'s email',
            realname: 'Name',
            realnameD: 'Please enter the user\'s real name',
            role: 'Role',
            roleM: 'Role',
            roleD: 'Please select a role for the user',
            company: 'Company',
            companyD: 'Please select a company for the user',
            opr: 'Operation',
            usernameLogin: 'Username',
            newCompany: 'Add Company',
            createNow: 'Create Now',
            reset: 'Reset',
            updateUser: 'Update User-',
            update: 'Update',
            cancel: 'Cancel',
            delete: 'Delete',
            emailP: 'Please enter the correct email format',
            lengthD150: 'The length is 1 to 50 characters',
            lengthD615: 'The length is 6 to 15 characters',
            lengthD115: 'The length is 1 to 15 characters',
            info: 'This operation will ban the user. Do you want to continue?',
            updateS: 'Update successfully',
            insertS: 'Insert successfully',
            inserterrUN:'Addition failed, username already exists!',
            inserterrN:'Addition failed, name already exists!',
            companyNotNull: 'Company can\'t be null',
            auth: 'Authorize',
            save: 'Save',
            deleteAdmin: 'Account admin cannot be deleted',
            deleteSelf: 'Unable to delete yourself',
            banUser: 'Ban'
        },
        agent: {
            select: 'Please enter a keyword search',
            id: 'Agent ID',
            name: 'Agent Name',
            companyName: 'Agency Name',
            contact: 'Agent Contact',
            logo: 'Agent Logo',
            opr: 'Operation',
            new: 'Add Agent',
            idD: 'Please enter the agent ID',
            nameD: 'Please enter the agent name',
            companyNameD: 'Please select a company for agent',
            contactD: 'Please enter agent contact information',
            uploadD: 'Files drag in or ',
            uploadLink: 'Click to upload',
            info: 'PNG file size limit 2MB',
            selectM: 'Please select',
            onlyNum: 'Please enter a valid Chinese mobile phone number',
            sameRow: 'Data already exists',
            btn: {
                new: 'Create',
                cancel: 'Cancel',
                delete: 'Delete'
            },
            logoD: 'Please upload agency Logo',
            lengthD120: 'The length is 1 to 20 characters',
            lengthD510: 'The length is 5 to 10 characters',
            lengthD7: 'The length is 7 characters',
            imageD: 'Upload images only in PNG format',
            imageSizeD: 'The size of the uploaded image cannot exceed 2MB',
            deleteDF: 'This operation will permanently delete the record. Do you want to continue?',
        },
        applyoutsider:{
            username:'Username',
            role:'Role',
            password:'Password',
            email:'Email',
            companyName:'Company',
            name:'Name',
            tipsrole:'please select a role',
            applysucc:'The registration is successful and will be reviewed by the administrator',
            tipsusername:'Please enter a username',
            tipspassword:'Please enter a password',
            tipsemail:'Please enter a email address',
            tipscompanyname:'Please enter a department',
            tipsname:'Please enter a real name',
            opexpert:'Expert',
            opuser:'Administrator',
            customer:'Customer',
            applytips:'Instructions',
            cert:'Qualifications',
            resume:'Curriculum vitae',
            inputapply:'Please enter instructions for your application',
            accountapply:'Expert Application',
        },
        mangeroutsider:{
            id:'ID',
            username:'Username',
            password:'Password',
            name:'Name',
            email:'Email',
            companyName:'Company',
            role:'Role',
            ispass:'Status',
            customer:'Customer',
            outsider:'Administrator',
            expert:'Expert',
            passto:'Pass',
            passun:'To be passed',
            passno:'Fail to pass',
            createTime:'Creation Time',
            auditusers:'Audit User',
            applyinstruction:'Instruction',
            attachment:'attachment',
            filename:'fileName',
            filetype:'type',
            userRole:'Role',
            passstatus:'Status',
            calcel:'Cancel',
            sure:'Confirm',
            inputuserrole:'Please select an identity role',  
        },
        serialReport:{
            from: 'From',
            to: 'To',
            printBtn: 'Print',
            resetBtn: 'Reset',
            projectCode: 'Project Code',
            itemCode: 'Item Code',
            serialNumber: 'Serial Number',
            salesOrderNumber: 'Sales Order Number',
            deliveryDate: 'Delivery Date',
            invoiceNumber: 'Invoice Number',
            invoiceDate: 'Invoice Date',
        },
        auth: {
            authIssueTypeTitle: 'User Issue Type Authorization',
            authIssueTypeUsername: 'Username',
            authIssueTypeCompany: 'Company',
            authIssueType: 'Issue Type',
        },
        material:{
            addmaterial:' Add Material',
            id:'Id',
            materialcode:'Material Code',
            material:'Material',
            materialprice:'Material Price',
            unit:'Unit',
            add:'Add',
            updatematerial:'Update Material',
            inmctips:'Please enter the material code',
            inmtips:'Please enter a name for the material',
            inmptips:'Please enter the price of the material',
            inmutips:'Please enter the unit of the material',
            mtype:'Material category',
            imtype:'Please select or create a material category.',
            inctips:'"Please select the currency"',
            addoktips:'Added successfully',
            adderrtips:'Addition failed',
            updateoktips:'Updated successfully',
            updateerrtips:'Update failed',
        },
        craft:{
            addcraft:'Add Process',
            id:'id',
            craftcode:'Process Code',
            craftdesc:'Process Desc',
            craftprice:'Process Price',
            unit:'Unit',
            createTime:'CreateTime',
            updateTime:'UpdateTime',
            updatecraft:'Update Process',
            incctips:'Please enter the craft code',
            incdtips:'Please enter a desc for the craft',
            incptips:'Please enter the price of the craft',
            incutips:'Please enter the unit of the craft',
        },
        purchase:{
            tomaterial:'Please select the material.',
            materialMultip:'material coeff.',
            tomMultiplier:'Please enter the material coefficient',
            craftnotnull:'The process cannot be empty.',
            mmnotnull:'The process coefficient cannot be empty.',
            tocraft:'Please select the craft',
            craftMult:'process coeff.',
            incmult:'Please enter the process coefficient.',
            inmmult:'Please enter the material coefficient',
            totalcost:'Total Cost',
            craft:'Process ',
            lossFactor:'loss coeff.',
            inputloss:'Please enter the loss coefficient',
            manageMultip:'Management Fee Ratio',
            inputManage:'Please enter the Management Fee Ratio',
            feeList:'Cost Details',
            cmFee:'Material and Process Cost',
            manageFee:'Management Fee',
            pcblist:'Purchase Cost List: ',
            inlnotnull:'loss coeff. not null',
            inwnotnull:'material coeff. not null',
            deleteHtips:'This operation will permanently delete the information. Are you sure you want to continue?',
            exportpcb:'Export Historical Data',
        },
        chatai:{
            chatai:'ChatAI',
            chatroom:'Chat Room',
            inputchat:'Please enter the question you need to know about.',
            fqa:'FQA',
            q1:'Hello, what can you do?',
            a1:'Hi, as an AI assistant, I can provide answers and assistance in many areas, including language and translation, daily life, current events and news, academics and education, programming and development, and more!',
        }


    }
}
const i18n = createI18n({
    locale: localStorage.getItem("lan") || 'zh-cn',
    fallbackLocale: localStorage.getItem('language') || 'zh-cn',
    globalInjection: true,
    messages,
})
export default i18n;
